module.exports = __webpack_public_path__ + "img/image126.dfc0fe20.png";